/** 跳转个人券列表的页面来源枚举 */
export enum PageSourceEnum {

  /** 首页搜索 */
  HOME_PRE_SEARCH = 'home_pre_search',
}
